<template>
    <div class="wrapper">
        <side-bar>
            <mobile-menu slot="content"></mobile-menu>
            <sidebar-link to="/categories" v-if="role < 2">
                <i class="nc-icon nc-notes"></i>
                <p>Категории цитат</p>
            </sidebar-link>
            <sidebar-link to="/quotes" v-if="role < 2">
                <i class="nc-icon nc-chat-round"></i>
                <p>Цитаты</p>
            </sidebar-link>
            <sidebar-link to="/images-categories" v-if="role < 2">
                <i class="nc-icon nc-tablet-2"></i>
                <p>Категории фонов</p>
            </sidebar-link>
            <span class="resetspan" @click="resetOffsets">
            <sidebar-link to="/images">
                    <i class="nc-icon nc-album-2"></i>
                    <p>Фоны</p>
            </sidebar-link>
            </span>
<!--            <sidebar-link to="/icons">-->
<!--                <i class="nc-icon nc-atom"></i>-->
<!--                <p>Icons</p>-->
<!--            </sidebar-link>-->
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <dashboard-content @click="toggleSidebar">

            </dashboard-content>

            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss">

    .resetspan {
        display: block;
        width: 100%;
    }
    .nav-link {
        cursor: pointer;
    }
</style>
<script>
    import TopNavbar from './TopNavbar.vue'
    import ContentFooter from './ContentFooter.vue'
    import DashboardContent from './Content.vue'
    import MobileMenu from './MobileMenu.vue'

    export default {
        components: {
            TopNavbar,
            ContentFooter,
            DashboardContent,
            MobileMenu
        },
        data() {
            return {
                role: parseInt(localStorage.getItem('role')) || 0,
            }
        },
        methods: {
            toggleSidebar () {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false)
                }
            },
            resetOffsets: function() {
                localStorage.setItem('w_active_offset', 0);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue